module.exports = __webpack_public_path__ + "static/media/home-gallery-image12.44349f6c.png";